module.exports = __webpack_public_path__ + "static/media/cleversell.235b4275.png";